@if ($lanes()?.length === 0) {
    <cm-full-page-feedback text="No run records for this job yet"></cm-full-page-feedback>
}
<div #container class="cm-timeline-container"></div>

<ng-template #timelineTooltip>
    @if ($tooltipData(); as data) {
        <div class="cm-timeline-tooltip">
            <strong [style.color]="data.color">{{ data.title }}</strong>
            @for (line of data.lines; track $index) {
                <span>{{ line }}</span>
            }
        </div>
    }
</ng-template>
